<template>
    <div v-if="showDialogue">
        <!-- 正常聊天窗口 -->
        <div v-if="!isMinimized" class="chat-window"
            :style="{ left: position.x + 'px', top: position.y + 'px', zIndex: zIndex }" @mousedown="bringToFront">
            <!-- 标题栏 - 可拖拽区域 -->
            <div class="chat-header" @mousedown="startDrag">
                <div class="chat-controls">
                    <button @click.stop="toggleMinimize">−</button>
                    <button @click.stop="closeChat">×</button>
                </div>
            </div>

            <!-- 聊天内容区域 -->
            <div class="chat-body" ref="chatBody">
                <!-- 欢迎区域 -->
                <div class="welcome-section flex Flexalign FlexBetween">
                    <div>
                        <div class="greeting">HI 我是阿吉狗！</div>
                        <div class="intro">很高兴能够为您服务</div>
                    </div>
                    <el-image class="ai_question_icon" :src="iconPath('ai_dog_logo.png')"></el-image>
                </div>

                <!-- 问题建议 -->
                <div class="suggestions p-15">
                    <div>您可以这样问我：</div>
                    <div class="suggestion-item" v-for="(suggestion, index) in suggestions" :key="index"
                        @click="selectSuggestion(suggestion.text)">
                        <div class="suggestion-text">{{ suggestion.text }}</div>
                    </div>
                </div>

                <!-- 消息列表 -->
                <div class="messages" v-if="messages.length > 0">
                    <div class="message" :class="message.sender" v-for="(message, index) in messages" :key="index">
                        <div class="message-bubble">{{ message.text }}</div>
                    </div>
                </div>
            </div>

            <!-- 输入区域 -->
            <div class="chat-footer">
                <div class="chat-input-container">
                    <input type="text" class="chat-input" placeholder="您有什么想知道的，快来问问我（按Enter发送）" v-model="inputText"
                        @keyup.enter="sendMessage">
                    <button class="send-button" @click="sendMessage">发送</button>
                </div>
            </div>
        </div>

        <!-- 最小化状态 -->
        <div v-else class="minimized-chat" :style="{ left: position.x + 'px', top: position.y + 'px', zIndex: zIndex }"
            @mousedown="bringToFront">
            <div class="minimized-title">HI 我是阿吉狗！</div>
            <div class="minimized-controls">
                <button @click.stop="toggleMinimize">□</button>
                <button @click.stop="closeChat">×</button>
            </div>
        </div>
    </div>
</template>

<script>
import * as Config from "../../config/config";
export default {
    name: 'ChatWindow',
    props: {
        initialPosition: {
            type: Object,
            default: function () {
                return { x: 100, y: 100 };
            }
        }
    },
    data() {
        return {
            showDialogue: false,
            isMinimized: false,
            inputText: '',
            messages: [],
            position: this.initialPosition,
            isDragging: false,
            dragOffset: { x: 0, y: 0 },
            zIndex: 1000,
            suggestions: [
                { text: '无二次函数曲线', tag: '2' },
                { text: '高中数学三角函数', tag: '2' },
                { text: '构建等边三角形并计算三角范围积', tag: '2' },
                { text: '构建等边三角形并计算三角范围积', tag: '2' },
                { text: '数学的艺术', tag: '2' }
            ]
        };
    },

    mounted() {
        // 初始位置设置为页面右下角
        this.position = this.initialPosition;
        this.getSSEId();
        this.getQuestionList();
    },
    beforeUnmount() {
        // 清理事件监听器
        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDrag);
    },
    methods: {
        getQuestionList() {
            this.$Api.question.getQuestionList({ page: 1, pageSize: 5 }).then(res => {
                console.log(res.data.data)
            }).catch(() => { })
        },
        async getSSEId(id) {
            // this.$Api.question.getSSEId({ conversationId: 3 }).then(res => {
            //     console.log(res.data.data)
            // }).catch(() => { })
            let token = this.$Cache.get('token');
            const response = await fetch(
                `${Config.API_BASE_URL}/smarts/sse/connect${id ? `?conversationId=${id}` : ""
                }`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "text/event-stream",
                        Authorization: token,
                    },
                    timeout:10000,
                }
            );
            console.log(response)
        },
        toggleMinimize() {
            this.isMinimized = !this.isMinimized;
        },
        closeChat() {
            // 触发关闭事件，让父组件处理
            this.showDialogue = false;
        },
        selectSuggestion(text) {
            this.inputText = text;
            this.sendMessage();
        },
        sendMessage() {
            if (this.inputText.trim() === '') return;

            // 添加用户消息
            this.messages.push({
                text: this.inputText,
                sender: 'user'
            });

            // 模拟AI回复
            setTimeout(() => {
                this.messages.push({
                    text: `关于"${this.inputText}"，这是一个很好的问题。在实际应用中，这里会显示AI的回答。`,
                    sender: 'bot'
                });

                // 滚动到最新消息
                this.$nextTick(() => {
                    const chatBody = this.$refs.chatBody;
                    if (chatBody) {
                        chatBody.scrollTop = chatBody.scrollHeight;
                    }
                });
            }, 500);

            this.inputText = '';
        },
        startDrag(e) {
            this.isDragging = true;
            this.dragOffset = {
                x: e.clientX - this.position.x,
                y: e.clientY - this.position.y
            };

            document.addEventListener('mousemove', this.onDrag);
            document.addEventListener('mouseup', this.stopDrag);
        },
        onDrag(e) {
            if (!this.isDragging) return;

            this.position = {
                x: e.clientX - this.dragOffset.x,
                y: e.clientY - this.dragOffset.y
            };
        },
        stopDrag() {
            this.isDragging = false;
            document.removeEventListener('mousemove', this.onDrag);
            document.removeEventListener('mouseup', this.stopDrag);
        },
        bringToFront() {
            this.zIndex += 1;
        }
    },
};
</script>

<style lang="scss" scoped>
.chat-window {
    width: 550px;
    height: 800px;
    background-color: #F5F9FF;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    position: absolute;
    overflow: hidden;
    transition: all 0.3s ease;
}

.chat-header {
    // background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
    background-image: url(../../../public/static/icon/ai_quetion_top_bg.png);
    color: white;
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: move;
    user-select: none;
    height: 300px;
    position: relative;
}

.chat-title {
    font-size: 18px;
    font-weight: 600;
}

.chat-controls {
    display: flex;
    gap: 10px;
    color: #5B5D64;
    position: absolute;
    top: 20px;
    right: 10px;
}

.chat-controls button {
    background: none;
    border: none;
    // color: white;
    cursor: pointer;
    font-size: 18px;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background 0.2s;
}

.chat-controls button:hover {
    background: rgba(255, 255, 255, 0.2);
}

.chat-body {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
    // background-color: #f8f9fa;
    margin-top: -300px;
}

.welcome-section {

    // text-align: center;
    // margin-bottom: 25px;
    .ai_question_icon {
        width: 140px;
        height: 160px;
    }
}

.avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
    margin: 0 auto 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 32px;
    font-weight: bold;
}

.greeting {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #333;
}

.intro {
    color: #666;
    font-size: 14px;
    line-height: 1.5;
}

.suggestions {
    display: flex;
    flex-direction: column;
    gap: 12px;
    background: white;
    margin-top: -30px;
    border-radius: 12px;
    margin-bottom: 20px;
}

.suggestion-item {
    border-radius: 10px;
    padding: 12px 15px;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid #eaeaea;
    display: flex;
    align-items: center;
    gap: 10px;
}

.suggestion-item:hover {
    background: #f0f4ff;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.05);
}

.suggestion-tag {
    background: #6a11cb;
    color: white;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: bold;
}

.suggestion-text {
    font-size: 14px;
    color: #333;
}

.chat-footer {
    padding: 15px;
    border-top: 1px solid #eee;
    background: white;
}

.chat-input-container {
    display: flex;
    gap: 10px;
}

.chat-input {
    flex: 1;
    padding: 12px 15px;
    border: 1px solid #ddd;
    border-radius: 25px;
    outline: none;
    font-size: 14px;
    transition: border 0.2s;
}

.chat-input:focus {
    border-color: #6a11cb;
}

.send-button {
    background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
    color: white;
    border: none;
    border-radius: 25px;
    padding: 0 20px;
    cursor: pointer;
    font-weight: 600;
    transition: transform 0.2s;
}

.send-button:hover {
    transform: scale(1.05);
}

.minimized-chat {
    width: 350px;
    height: 60px;
    background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 15px;
    color: white;
    cursor: pointer;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    position: absolute;
}

.minimized-title {
    font-weight: 600;
    font-size: 16px;
}

.minimized-controls {
    display: flex;
    gap: 10px;
}

.minimized-controls button {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    font-size: 16px;
}

.message {
    margin-bottom: 15px;
    display: flex;
}

.message.user {
    justify-content: flex-end;
}

.message.bot {
    justify-content: flex-start;
}

.message-bubble {
    max-width: 80%;
    padding: 12px 16px;
    border-radius: 18px;
    font-size: 14px;
    line-height: 1.4;
}

.message.user .message-bubble {
    background: linear-gradient(135deg, #6a11cb 0%, #2575fc 100%);
    color: white;
    border-bottom-right-radius: 4px;
}

.message.bot .message-bubble {
    background: white;
    color: #333;
    border: 1px solid #eaeaea;
    border-bottom-left-radius: 4px;
}
</style>